import Card from "../../components/Directories/Card";
import ViewList from "../../components/Templates/ViewList";
import useDirectoriesContainer from "../../containers/Directories/useDirectoriesContainer";
import { useContent } from "../../content/useContent";
import { Routes } from "../../routes/Routes";

const Directories = () => {
  const {
    directories,
    pageLoading,
    handleSearch,
    searchValue,
    page,
    handleChangePage,
    rowsPerPage,
    handleClick,

    handleOpenDelete,
    handleDelete,
    handleEdit,
    selected,
    openDeleteDialog,
    setOpenDeleteDialog,
    loading,
  } = useDirectoriesContainer();

  const { directories: content } = useContent().pages;

  type IProps = {
    row: any;
  };

  const Row: React.FC<IProps> = ({ row }) => {
    return (
      <Card
        handleClick={handleClick}
        row={row}
        handleOpenDelete={handleOpenDelete}
        handleEdit={handleEdit}
      />
    );
  };

  return (
    <ViewList
      title={content.title}
      multiTitle={content.multi}
      selectRef="name"
      pageLoading={pageLoading}
      searchValue={searchValue}
      handleSearch={handleSearch}
      rowsPerPage={rowsPerPage}
      page={page}
      rows={directories}
      handleChangePage={handleChangePage}
      Row={Row}
      addPath={Routes.addDirectory}
      selected={selected}
      handleDelete={handleDelete}
      openDeleteDialog={openDeleteDialog}
      setOpenDeleteDialog={setOpenDeleteDialog}
      deleteLoading={loading}
    />
  );
};

export default Directories;
